import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Environment, useGLTF } from "@react-three/drei";
import "../threedmodel/model.css";

// Image imports
import fullestate from "../../../assets/models/fullestate.png";
import uppervilla from "../../../assets/models/villaupper.jpg";
import lowervilla from "../../../assets/models/villa-lower.jpg";
import cottages from "../../../assets/models/cottage1-2.jpg";
import occupancy from "../../../assets/models/estateoccupancy.jpg";

// Path to the 3D model file in the public directory
// import MODEL_PATH from "../../../../public/model.glb";

// 3D Model Viewer Component
const ThreeDModelViewer = () => {
  // const MODEL_PATH = "/model.glb";

  // const { scene } = useGLTF(MODEL_PATH);

  return (
    <Canvas
      style={{
        borderRadius: "10px",
        margin: "20px 0",
        margin:"auto"
      }}
      camera={{ position: [2, 5, 14], fov: 80 }}
    >
      <ambientLight intensity={0.2} />
      <directionalLight position={[5, 5, 5]} />
      {/* <primitive object={scene} /> */}
      <OrbitControls enableZoom={true} />
      <Environment preset="sunset" />
    </Canvas>
  );
};

// Main Component
const Model = () => {
  const images = [fullestate, uppervilla, lowervilla, cottages, occupancy];

  return (
    <>
      {/* Carousel Section */}
      <section className="threedmodel py-5 px-md-5 px-3">
        <div className="container-fluid modeldiv px-md-5 px-0">
          <Swiper
            modules={[Pagination, Navigation]}
            pagination={{ clickable: true }}
            navigation
            loop={true}
            className="threeswiper"
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <img src={image} alt={`Slide ${index + 1}`} loading="lazy"/>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* 3D Model Viewer Section */}
      {/* <section className="threeDmodel py-5 px-md-5 px-3">
        <div className="container-fluid text-center">
          <h2 className="text-white">Explore the 3D Model</h2>
         <p>Interact with our custom 3D model below:</p>
          <ThreeDModelViewer /> 
        </div>
      </section> */}
    </>
  );
};

export default Model;
